import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";
import { validateLimitRateParams } from '../validateLimitRateParams/validateLimitRateParams';

var getLeftTime = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id, throttle, storage) {
    var lastTime;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = Number;
            _context.next = 3;
            return storage.get(id);

          case 3:
            _context.t1 = _context.sent;

            if (_context.t1) {
              _context.next = 6;
              break;
            }

            _context.t1 = 0;

          case 6:
            _context.t2 = _context.t1;
            lastTime = (0, _context.t0)(_context.t2);
            return _context.abrupt("return", throttle - Date.now() + lastTime);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getLeftTime(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

export var isLimitRateHit = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(defaultID, options, storage) {
    var id, leftTime;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(!options.throttle || !storage)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", false);

          case 2:
            validateLimitRateParams(options.throttle, options.id);
            id = options.id || defaultID;
            _context2.next = 6;
            return getLeftTime(id, options.throttle, storage);

          case 6:
            leftTime = _context2.sent;

            if (!(leftTime > 0)) {
              _context2.next = 9;
              break;
            }

            return _context2.abrupt("return", true);

          case 9:
            _context2.next = 11;
            return storage.set(id, Date.now().toString());

          case 11:
            return _context2.abrupt("return", false);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function isLimitRateHit(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();